export const Expand = ({
    ...props
  }: React.SVGProps<SVGSVGElement> ) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 0C0.906937 0 0 0.906937 0 2V6H2V2H6V0H2ZM12 0V2H16V6H18V2C18 0.906937 17.0931 0 16 0H12ZM0 12V16C0 17.0931 0.906937 18 2 18H6V16H2V12H0ZM16 12V16H12V18H16C17.0931 18 18 17.0931 18 16V12H16Z" fill={props.color}/>
    </svg>
);
